import { formConfigurationMapping, type TFormConfig } from './index';

export function getFormConfigByTemplateCode(templateCode?: string | null): TFormConfig | undefined {
  if (!templateCode) {
    return undefined;
  }

  const normalized = templateCode.trim();

  return formConfigurationMapping.find((fcm) => fcm.formCode === normalized) as TFormConfig | undefined;
}
